import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { param } from 'jquery';
import { Subject } from 'rxjs';
import { QueryParams, rgxKanaFullW , rgxKanaHalfW} from 'src/app/shared/constant';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { ScrSendingAuthenMailService} from 'src/app/modules/examinee/auth/scr-sending-authen-mail/scr-sending-authen-mail.service';

@Component({
  selector: 'app-scr-sending-authen-mail',
  templateUrl: './scr-sending-authen-mail.component.html',
  styleUrls: ['./scr-sending-authen-mail.component.scss']
})
export class ScrSendingAuthenMailComponent implements OnInit {

  htOrgCode: string;
  consulId: string;
  userId: string;
  dateOfBirth: string;
  consulNum: string;
  consulDay: string;
  isMailErr = false;
  errMsg = '';
  public mailAddress: string;
  emailValidation = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: ScrSendingAuthenMailService,
    private loading: LoadingService,
    public util: Utility,
    private dialogModalService: DialogModalService,
    ) {
     }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.htOrgCode =  this.activatedRoute.snapshot.queryParams[QueryParams.HtOrgCode];
    this.consulId =  this.activatedRoute.snapshot.queryParams[QueryParams.ConsulId];
    this.dateOfBirth =  this.activatedRoute.snapshot.queryParams[QueryParams.DateOfBirth];
    this.consulNum =  this.activatedRoute.snapshot.queryParams[QueryParams.ConsulNum];
    this.consulDay =  this.activatedRoute.snapshot.queryParams[QueryParams.ConsulDay];
    if (this.consulId === undefined){
      this.consulId = null;
    }
    else{
      if(sessionStorage.getItem('is0106'))
      {
        this.consulId = sessionStorage.getItem('id0106');
      }
    }
  }

  checkMail(event){
    const kanaText = event.key;
    if ((event.charCode >= 32 && event.charCode  <= 42) || (event.charCode >= 58 && event.charCode <= 63) || event.charCode === 44
    || (event.charCode >= 123 && event.charCode  <= 126) || (event.charCode >= 91 && event.charCode  <= 96 && (event.charCode !== 95))
    ){
     return false;
    }
    if (rgxKanaFullW.test(kanaText) === true ) {
      return false;
    }
    if (rgxKanaHalfW.test(kanaText) === true ) {
      return false;
    }
    return true;
  }
  removeBorder(){
    $('.ctrl').removeClass('error-border');
    this.errMsg = '';
  }
  validateEmail(pVal: string) {
    if (!this.util.isNullOrBlank(pVal) && !this.emailValidation.test(pVal)) {
      return false;
    }
    if (pVal.length < 6 || pVal.length > 254) {
      return false;
    }
    return true;
  }
  sendMail(){
    this.isMailErr = false;
    $('.ctrl').removeClass('error-border');
    if (this.util.isNullOrEmpty(this.mailAddress)) {
      const mess = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED').replace('{0}', this.translate.instant('STR_EMAIL_ADDRESS'));
      this.errMsg = mess;
      this.isMailErr = true;
      $('.ctrl').addClass('error-border');
      return;
    }
    if (!this.validateEmail(this.mailAddress)) {
      $('.ctrl').addClass('error-border');
      this.errMsg = this.translate.instant('MESS_ERR_EMAIL_WRONG_FORMAT');
      this.isMailErr = true;
      return ;
    }
    this.loading.setDisplay(true);
    const lang = localStorage.getItem('language');
    let language = '';
    if ( lang === 'vi')
    {
      language = 'VN';
    }
    else if ( lang === 'en')
    {
      language = 'EN';
    }
    else{
      language = 'JP';
    }
    
    const obj = {
      Mail: this.mailAddress.toLowerCase(),
      HTOrgCode: this.htOrgCode,
      UserID: null,
      ConsulID: this.util.isNullOrEmpty(this.consulId) ? sessionStorage.getItem('id0106') : this.consulId ,
      Language: language,
      IsQR: this.util.isNullOrEmpty(sessionStorage.getItem('is0106')) ? false : true,
      IsConsulID: this.util.isNullOrEmpty(this.consulId),
      ConsulDay: this.util.isNullOrEmpty(this.consulDay) ? sessionStorage.getItem('id0107') : this.consulDay,
      ConsulNum: this.util.isNullOrEmpty(this.consulNum) ? sessionStorage.getItem('id0108') : this.consulNum,
      DateOfBirth: this.util.isNullOrEmpty(this.dateOfBirth) ? sessionStorage.getItem('id0109') : this.dateOfBirth,
    };

    this.service.sendEmailVerify(obj).subscribe(res => {
      this.loading.setDisplay(false);
      if (this.util.isNullOrEmpty(res) || res.length === 0)  {
       return;
      }
      this.isMailErr = false;
      if (res === 'F'){
       this.isMailErr = true;
       this.errMsg = this.translate.instant('MESS_ERR_REGISTERED_MAIL_ADD');
       $('.ctrl').addClass('error-border');
       return;
      }
      if (res === 'S'){
        this.dialogModalService.openInfoModal(this.translate.instant('MESS_INF_MAIL_WASSENT'));
        return;
       }
    });
  }
  goLogin(){
    this.isMailErr = false;
    sessionStorage.setItem('exam-authen-email', this.mailAddress);
    sessionStorage.setItem('id0104', this.consulId?.trim());
    this.router.navigate(['/'], { queryParams: { htorgcode: this.htOrgCode, consulid : this.consulId } });
  }

}
